import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const PageNotFound = () => {
    return _jsx("div", Object.assign({ style: { margin: 24 } }, { children: "Page not found" }));
};
